import { Entity } from '@backstage/catalog-model';

import { AZURE_ANNOTATION_RESOURCE_TAG_SELECTOR } from '../types';

export const isTagSelectorAvailable = (entity: Entity): boolean => {
  return Boolean(
    entity?.metadata.annotations?.[AZURE_ANNOTATION_RESOURCE_TAG_SELECTOR],
  );
};
